import { jQuery as $ } from 'mk/jQuery';
import { photoblog_ninja_album_url } from 'mk/urls/functions';
import { mountAlbum, unmountAlbum } from 'mk2/apps/blogs/miniapps';

export function unmount(album) {
    unmountAlbum(album);
}

export function run(container, album, currentIndex, isAdmin, isAlbumPopup, imageId, counter, wasCancelled) {
    $.getJSON(photoblog_ninja_album_url(album), (data) => {
        if (wasCancelled && wasCancelled(counter)) {
            return;
        }
        mountAlbum(container, album, data, currentIndex, isAdmin, isAlbumPopup, imageId);
    });
}
